import styled from 'styled-components';
import Button from '../../atoms/Button';
import { colors, opacities } from '../../../defaultTheme';
import query from '../../../const/mediaQueries';
// shared header/footer styles
export const sharedElementStyles = `
  display: flex;
  align-items: center;
`;
// darkened overlay styles - need to use pseudo element
export const Overlay = styled.div `
  ${({ isOpen }) => isOpen &&
    `
    :after {
      content: "";
      display: block;
      position: fixed;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      z-index: 1;
      background-color: ${opacities.rgbaHalfOpacity};
    }
  `}
`;
export const Container = styled.div `
  display: flex;
  flex-direction: column;
  position: fixed;
  right: -768px;
  top: 0;
  z-index: 2;
  background-color: ${colors.white};
  width: 100vw;
  overflow-y: auto;
  height: 100%;
  transition: right 400ms ease-in-out;

  @media ${query.greaterThanMedium} {
    max-width: 768px;
    box-shadow: -6px 0 20px 0 ${opacities.rgbaLight12};
  }
`;
/**
 * Reason to add conditional style based on footer prop is:
 * if we are adding display flex to modal content, footer is not properly aligned on storybook knob - SlideInModal in safari browser.
 * Since added conditional style to address the safari issue.
 */
export const ModalContent = styled.div `
  ${({ hasFooter }) => !hasFooter &&
    `
      display: flex;
      flex-direction: column;
    `}

  flex-grow: 1;
  flex-shrink: 0;
`;
export const FooterContainer = styled.div `
  bottom: 0;
  position: sticky;

  @media ${query.lessThanMedium} {
    position: initial;
  }
`;
export const FooterButton = styled(Button) `
  margin: 0;
  min-width: 100%;
  margin-bottom: 8px;

  @media ${query.greaterThanMedium} {
    min-width: 120px;
    margin-bottom: 0;
    margin-left: 8px;
  }
`;
export const FooterWrapper = styled.div `
  padding: 0px 16px;
  background: ${colors.lightestGrey};
  ${sharedElementStyles}
  min-height: 152px;
  flex-direction: column-reverse;
  justify-content: center;
  border-top: 1px solid ${colors.lightGrey};
  box-sizing: border-box;

  @media ${query.greaterThanMedium} {
    height: 96px;
    min-height: 96px;
    padding: 0 24px;
    flex-direction: row;
    justify-content: flex-end;
  }
`;
//# sourceMappingURL=subcomponents.js.map